import React from "react";

export interface VideoContentItemProps {
  index: number;
  title: string;
  subtitle?: string;
  duration?: string;
  thumbnailUrl?: string;
  onClick: () => void;
  isActive?: boolean;
  isCompleted?: boolean;
  disabled?: boolean;
}

function VideoContentItem({
  index,
  title,
  subtitle,
  duration,
  thumbnailUrl,
  onClick,
  isActive = false,
  isCompleted = false,
  disabled = false,
}: VideoContentItemProps) {
  const secondaryText = duration ?? subtitle;
  const isPlaying = isActive;
  const isWatched = isCompleted && !isActive;
  const showReplay = isWatched;

  const rootClass = [
    "video-content-item",
    isPlaying && "video-content-item--playing",
    isWatched && "video-content-item--watched",
    disabled && "video-content-item--disabled",
  ]
    .filter(Boolean)
    .join(" ");

  const overlayClass = [
    "video-content-item__overlay",
    showReplay
      ? "video-content-item__overlay--replay"
      : "video-content-item__overlay--play",
  ].join(" ");

  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      className={rootClass}
      onClick={disabled ? undefined : onClick}
    >
      <span className="video-content-item__index">{index}.</span>

      <div className="video-content-item__thumb">
        {thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt=""
            className="video-content-item__thumb-img"
          />
        ) : (
          <div className="video-content-item__thumb-placeholder" />
        )}
        <div className={overlayClass} aria-hidden>
          <i className={showReplay ? "las la-redo" : "las la-play-circle"} />
        </div>
      </div>

      <div className="video-content-item__text">
        <p className="video-content-item__title">{title}</p>
        {secondaryText != null && secondaryText !== "" && (
          <p className="video-content-item__desc">{secondaryText}</p>
        )}
      </div>
    </div>
  );
}

export default VideoContentItem;
